'use strict';

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _is = require('is');

var _is2 = _interopRequireDefault(_is);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _init = require('./init');

var _response = require('./response');

var _response2 = _interopRequireDefault(_response);

var _errors = require('./errors');

var GenericResource = (function () {
    /**
     *
     * @param apiEndpoint String value which supports syntax of _.template
     * @param expectedStatus
     * @param [mutateResponse] Function to modify the response before resolving it
     */

    function GenericResource(apiEndpoint, expectedStatus, mutateResponse) {
        _classCallCheck(this, GenericResource);

        this.apiEndpoint = (0, _init.getConfig)('API_BASE') + apiEndpoint;
        this.expectedStatus = expectedStatus || 200;

        if (!_is2['default'].array(this.expectedStatus)) {
            this.expectedStatus = [this.expectedStatus];
        }

        if (_is2['default'].fn(mutateResponse)) {
            this.mutateResponse = mutateResponse;
        } else {
            this.mutateResponse = function (response) {
                return response;
            };
        }
    }

    _createClass(GenericResource, [{
        key: 'getCookies',
        value: function getCookies() {
            var cookieVal = (0, _init.getCookies)();

            if (cookieVal) {
                (function () {
                    var pairs = [];

                    _Object$keys(cookieVal).forEach(function (key) {
                        pairs.push(_cookie2['default'].serialize(key, cookieVal[key]));
                    });

                    cookieVal = pairs.join('; ');
                })();
            }

            return cookieVal;
        }
    }, {
        key: 'wrapResponse',
        value: function wrapResponse(res, error) {
            return new _response2['default'](res, error);
        }
    }, {
        key: 'handleRequest',
        value: function handleRequest(req) {
            var _this = this;

            return this.ensureStatusAndJson(new _Promise(function (resolve) {
                var headers = _lodash2['default'].extend({
                    Accept: 'application/json'
                }, (0, _init.getExtraHeaders)());

                var cookieVal = _this.getCookies();
                if (cookieVal) {
                    headers.Cookie = cookieVal;
                }

                if (headers && _is2['default'].object(headers)) {
                    _Object$keys(headers).forEach(function (key) {
                        if (_is2['default'].defined(headers[key]) && !_is2['default'].nil(headers[key])) {
                            req = _this.setHeader(req, key, headers[key]);
                        }
                    });
                }

                _this.doRequest(req, function (response, error) {
                    return resolve(_this.wrapResponse(response, error));
                });
            }));
        }
    }, {
        key: 'ensureStatusAndJson',
        value: function ensureStatusAndJson(prom) {
            var _this2 = this;

            return prom.then(function (res) {
                // Check expected status & error
                if (res && !res.hasError && _this2.expectedStatus.indexOf(res.status) !== -1) {
                    return _this2.mutateResponse(res.body);
                } else {
                    if (res) {
                        // Throw a InvalidResponseCode error
                        throw new _errors.InvalidResponseCode(res.status, res.statusType, res.text);
                    } else {
                        // Throw a Generic error since the request failed
                        throw res.error || new Error('Something went awfully wrong with the request, check network log.');
                    }
                }
            })['catch'](function (error) {
                // Rethrow any errors
                throw error;
            });
        }
    }, {
        key: 'buildThePath',
        value: function buildThePath(urlParams) {
            var thePath = this.apiEndpoint;

            if (urlParams && !(_is2['default'].object(urlParams) && _Object$keys(urlParams).length === 0)) {
                thePath = _lodash2['default'].template(this.apiEndpoint)(urlParams);
            }

            return thePath;
        }
    }, {
        key: 'onSourceError',
        value: function onSourceError(error) {
            return (0, _init.getOnSourceError)(error);
        }
    }, {
        key: 'createRequest',
        value: function createRequest(method, url, query, data) {
            throw new Error('Not implemented');
        }
    }, {
        key: 'doRequest',
        value: function doRequest(req, resolve) {
            throw new Error('Not implemented');
        }
    }, {
        key: 'setHeader',
        value: function setHeader(req, key, value) {
            throw new Error('Not implemented');
        }
    }]);

    return GenericResource;
})();

exports['default'] = GenericResource;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/base.js
 ** module id = 1051
 ** module chunks = 1
 **/